enum PolitiqueConfidentialiteEnum {
	ACCEPTED = 'accepted',
	REFUSED = 'refused',
}
export default PolitiqueConfidentialiteEnum;
